import Person from '../../assets/arts/funcSession1.png'
import './section1.css'

const areas = [
    'SAP & ABAP',
    'SAP Fiori',
    'Business Intelligence',
    'Integrações de Sistemas',
    'Desenvolvimento Web',
    'Aplicativos Mobile',
    'Automação de Processos',
]

export default function Section1() {
    return (
        <div id="section1" className="container-fluid">
            <div className="row d-flex justify-content-start no-gutters">

                {/* Imagem — somente desktop */}
                <div className="col-5 d-md-flex d-none bgImg" style={{ minHeight: 520 }} />

                {/* Imagem — mobile */}
                <div className="col-12 d-md-none">
                    <img width="100%" src={Person} alt="Equipe Oxfield" />
                </div>

                {/* Conteúdo */}
                <div className="col-md-6 col-12 d-flex align-items-center p-md-5 p-4">
                    <div style={{ maxWidth: 560 }}>

                        <label className="tituloSection tituloSection1">Quem Somos</label>

                        <div data-aos="fade-up">
                            <p className="subTituloSection mt-3">
                                Apoiamos empresas a resolver desafios complexos com{' '}
                                <span style={{ color: 'var(--orange)' }}>tecnologia de alto nível</span>
                            </p>
                        </div>

                        <div data-aos="fade-up">
                            <p className="textoSection mt-4">
                                A Oxfield é uma empresa de consultoria e desenvolvimento de software
                                fundada por profissionais com ampla experiência em processos empresariais
                                e alta capacidade técnica. Nossa missão é entregar produtos escaláveis,
                                transparentes e construídos com arquitetura limpa — de ponta a ponta.
                            </p>
                            <p className="textoSection mt-2">
                                Atuamos em setores como energia, indústria, saúde e financeiro,
                                sempre com foco em resultados duradouros e baixo custo de operação.
                            </p>
                        </div>

                        {/* Áreas de atuação */}
                        <div data-aos="fade-up" className="areas-grid mt-4">
                            {areas.map(a => (
                                <span key={a} className="area-tag">
                                    <span className="area-tag-dot" />
                                    {a}
                                </span>
                            ))}
                        </div>

                        {/* Mini-stats */}
                        <div data-aos="fade-up" className="d-flex gap-3 mt-5" style={{ gap: 12 }}>
                            <div className="inline-stat">
                                <strong>10+</strong>
                                <span>Anos de experiência</span>
                            </div>
                            <div className="inline-stat">
                                <strong>200+</strong>
                                <span>Projetos entregues</span>
                            </div>
                            <div className="inline-stat">
                                <strong>15+</strong>
                                <span>Clientes ativos</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
